import { render, staticRenderFns } from "./ExternalDataPropertyEditor.vue?vue&type=template&id=be74a8a0&scoped=true&"
import script from "./ExternalDataPropertyEditor.vue?vue&type=script&lang=ts&"
export * from "./ExternalDataPropertyEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be74a8a0",
  null
  
)

export default component.exports